export const API = {
    SESSION: {
        GET_SESSION: `/session`,
    },
    USER: {
        GET: `/user`,
        LANDING_PAGE: `/user/default_landing_page`,
        IDENTIFY_PERSON: `/user/identify_person`,
        LINK_PERSON: `/user/link_person`,
        UPDATE_DETAILS: `/user/update_user_details`,
        SET_PASSWORD: `/user/set_password`,
        UPDATE_OPTINS: `/user/optin`,
        LD_INSIGHT_VIEW: `/user/register_event`,
        ORGS: `/user/orgs`,
        SELECTED_ORG: `/user/selected_org`,
    },
    COMPANY: {
        SEARCH_COMPANY: `/company/opensearch`,
        SEARCH_COMPANY_DISCOVER: `/company/opensearch/discover`,
        PRODUCTS_SECTORS_LIST: `/company/products_sectors_list`,
        GET_COMPANY: `/company`,
        PRODUCT: `/company/product`,
        PRODUCT_SEARCH: `/company/product/search`,
        SECTOR: `/company/sector`,
        CSV: `/company/csv_by_company_ids`,
    },
    TEAM: {
        GET_LEADERSHIP_TEAM: `/leadership/team`,
        GET_ROLES: `/leadership/role`,
    },
    PERSON: {
        CREATE: `/person`,
        GET_FIELD: `/person`,
        BASIC_SEARCH_PERSON: `/person/opensearch/work_history`,
        SEARCH_PERSON_OS: `/person/opensearch`,
        SEARCH: `/person/opensearch`,
        SEARCH_DISCOVER: `/person/opensearch/discover`,
        GET_CANDIDATE_ROLES: `/person/role/search`,
        GET_PERSON_CRM_ID: `/person/get_person_crm_id`,
        CSV: `/person/csv_by_person_ids`,
        UPDATE_WORK_HISTORY: `/person/work_history`,
    },
    CHARTS: `/leadership/graphing`,
    LOCATION: {
        SEARCH: `/location/search`,
        COUNTRY: `/location/country/search`,
        COUNTRY_BY_ID: `/location/country`,
        LOCATION_BY_ID: `/location`,
    },
    STATE: {
        SEARCH: (groupId: number, userId: number): string => `/group/${groupId}/user/${userId}/state/type/search`,
        SEARCHBYID: (groupId: number, userId: number, stateId: number): string =>
            `/group/${groupId}/user/${userId}/state/type/search/${stateId}`,
        SEARCHBYGROUP: (groupId: number): string => `/group/${groupId}/state/type/search`,
        SEARCHBYSTATE: (stateId: number): string => `/state/${stateId}/metadata`,
    },
    PACE: {
        USER: `/pace/user`,
        GROUP: `/pace/group`,
    },
    PACE_DASHBOARD: {
        BEHAVIOURAL_COMPARISON: (orgId: number) => `/pace_dashboard/org/${orgId}/graph/behavioural_comparison`,
        INDIVIDUALS_REF: (orgId: number) => `/pace_dashboard/org/${orgId}/ref/individuals`,
        TEAMS_REF: (orgId: number) => `/pace_dashboard/org/${orgId}/ref/distinct_teams`,
        USERS: `/pace_dashboard/users/teams`,
        TEAMS: (userId: number) => `/pace_dashboard/user/${userId}/teams`,
        MY_PACE: `/pace_dashboard/my_pace`,
        MY_HUB_PACE: `/pace_dashboard/my_hub_pace`,
    },
    CRM: {
        IDENTIFY: `/crm/identify_contacts`,
        VACANCIES: `/crm/vacancies`,
        CONTACTS_VACANCY: `/crm/contacts_by_vacancy`,
        ADD_CONTACTS_CRM: `/crm/add_contacts_to_crm`,
        ADD_CONTACTS_VACANCY: `/crm/add_contacts_to_vacancy`,
    },
    REFERENCE: {
        WORK_POSITION: `/reference/work_position`,
        DRX_WORK_POSITION: `/reference/drx_work_position`,
    },
    LEADERSHIP: {
        LSPM: "/leadership/lspm",
        PACE_LABS_GRAPHING: "/leadership/graphing_for_labs",
        TENURE_CHART: "/leadership/tenure_chart",
    },
    PROJECT: {
        GET: `/project`,
        SEARCH: `/project/search`,
        FUNCTIONS_LEVELS: `/project/list_role_functions`,
    },
    USER_MANAGEMENT: {
        GET_USERS: `/sys_admin/user_management`,
        TEAMS: `/sys_admin/ref/distinct_teams`,
        NEW_TEAM: `/sys_admin/users/teams`,
        DELETE_TEAM_FROM_USER: (user_id: number) => `/sys_admin/user/${user_id}/teams`,
        ARCHIVE_USER: (user_id: number) => `/sys_admin/user/${user_id}/disable`,
        UNARCHIVE_USER: (user_id: number) => `/sys_admin/user/${user_id}/enable`,
        ADD_TO_GROUP: (user_id: number) => `/sys_admin/user/${user_id}/groups`,
        DELETE_FROM_GROUP: (user_id: number) => `/sys_admin/user/${user_id}/groups`,
        GET_INVITATIONS: `/sys_admin/list_invites`,
        SEND_INVITATIONS: `/sys_admin/user_invite`,
        UPDATE_USER_ROLES: (user_id: number, group_id: number) => `/sys_admin/user/${user_id}/group/${group_id}/roles`,
        UPDATE_USER_FUNCTION: (user_id: number, group_id: number) =>
            `/sys_admin/user/${user_id}/group/${group_id}/function`,
    },
    SYSADMIN: {
        ORG: `/sys_admin/org`,
        CLIENT_HUB: `/sys_admin/client_hub`,
        PACE_PORTAL: `/sys_admin/pace_portal`,
        PERMISSIONS_REF: `/sys_admin/ref/roles`,
        PERMISSIONS_REF_BUNDLE: `/sys_admin/ref/role_bundles`,
        GET_CLIENT_HUB: (org_id: number) => `/sys_admin/client_hub/${org_id}`,
        SEND_REMINDER_BY_USER_ID: `/sys_admin/user_invite_by_invitee_user_id`,
    },
};
